import { createStyles, Theme } from '@material-ui/core'

export const styles = (theme: Theme) =>
  createStyles({
    formWithOutToolbar: {
      '& .MuiToolbar-gutters': {
        paddingLeft: theme.spacing(0),
        display: 'none'
      },
      '& .DialogContent-dividers': {
        padding: 0
      }
    }
  })
